import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import DeleteIcon from "@mui/icons-material/Delete";
//import AddIcon from "@mui/icons-material/Add";
import PropTypes from "prop-types";
import swal from "sweetalert";
import { deleteCompany } from "rest/requests";

const ITEM_HEIGHT = 48;

export default function CompaniesActionMenu({ setIsEditingCompany, element, setElementToEdit }) {
  const rowElement = element;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const edit = () => {
    setAnchorEl(null);
    if (setIsEditingCompany !== null) {
      setIsEditingCompany(true);
      setElementToEdit(rowElement);
    }
  };

  const deleteUserFunction = () => {
    swal({
      title: "Confirmación antes de eliminar",
      text: "Una vez eliminada la empresa no se podra recuperar",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteCompany(element.id)
          .then((req, res) => {
            console.log("Success..", res);
            swal("La empresa ha sido eliminada exitosamente", {
              icon: "success",
            });
            setIsEditingCompany(null);
            setIsEditingCompany(false);
          })
          .catch((error) => {
            console.log("Error...", error);
            swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
          });
      } else {
        swal("El proceso de eliminacion a sido detenido. Su Empresa esta a salvo!");
      }
    });
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
      >
        <MenuItem key="Editar" onClick={edit}>
          <EditIcon color="success" />
          &nbsp;Editar
        </MenuItem>
        <Divider />
        <MenuItem key="Eliminar" onClick={() => deleteUserFunction()}>
          <DeleteIcon color="primary" />
          &nbsp;Eliminar
        </MenuItem>
        <Divider />
        {/* <MenuItem key="Agregar" onClick={add}>
          <AddIcon color="dark" />
          &nbsp;Agregar
        </MenuItem>
        <Divider /> */}
      </Menu>
    </div>
  );
}

CompaniesActionMenu.defaultProps = {
  setIsEditingCompany: null,
  element: {},
  setElementToEdit: null,
};

CompaniesActionMenu.propTypes = {
  setIsEditingCompany: PropTypes.any,
  element: PropTypes.object,
  setElementToEdit: PropTypes.func,
};
